<template lang="pug">
.create-update-pet
  v-overlay(v-if="update", :value="overlay")
    v-progress-circular(indeterminate, size="64")
  v-card
    v-toolbar(color="primary", dark, flat)
      v-toolbar-title {{ update ? 'Actualizar' : 'Creación de' }} Mascota
    .alert(v-if="messages_error_request")
      v-alert(border="top", color="red lighten-2", dark)
        ul
          li(v-for="message in messages_error_request") {{ message }}
    v-card-text
      ValidationObserver(ref="observer_pet_data", v-slot="{ validate, reset }")
        v-form
          v-row
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Nombre y Apellido"
              )
                v-text-field(
                  v-model="pet.name",
                  label="Nombre y Apellido",
                  type="text",
                  :error-messages="errors",
                  clearable,
                  required
                )
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Nacimiento"
              )
                v-menu(
                  v-model="menu_date",
                  :close-on-content-click="false",
                  transition="scale-transition",
                  offset-y,
                  max-width="290px",
                  min-width="290px"
                )
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="dateFormatted",
                      label="Nacimiento",
                      clearable,
                      persistent-hint,
                      readonly,
                      v-on="on",
                      @click:clear="pet.birthday = null"
                    )
                  v-date-picker(
                    v-model="pet.birthday",
                    no-title,
                    @input="menu_date = false"
                  )
          v-row(v-if="user.role.slug != 'owner'")
            v-col(:cols="user.role.slug == 'vet' ? '12' : '12'")
              ValidationProvider(
                v-slot="{ errors }",
                name="Propietario",
                rules="required"
              )
                v-autocomplete(
                  required,
                  single-line,
                  hide-details,
                  item-value="id",
                  item-text="email",
                  :items="owners",
                  label="Propietario",
                  v-model="pet.owner",
                  :error-messages="errors",
                  :disabled="user.role.slug=='owner'",
                )
          v-row
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Color",
                rules="required"
              )
                v-text-field(
                  v-model="pet.color",
                  label="Color",
                  type="text",
                  :error-messages="errors",
                  clearable,
                  required
                )
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Peso|numeric",
                rules="required"
              )
                v-text-field(
                  v-model="pet.weight",
                  label="Peso (kg)",
                  type="number",
                  :error-messages="errors",
                  clearable,
                  required
                )
          v-row
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Raza",
                rules="required"
              )
                v-text-field(
                  v-model="pet.race",
                  label="Raza",
                  type="text",
                  :error-messages="errors",
                  clearable,
                  required
                )
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Genero",
                rules="required"
              )
                v-autocomplete(
                  v-model="pet.gender",
                  label="Genero",
                  :items="choices.gender",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Tipo de Comida",
                rules="required"
              )
                v-text-field(
                  v-model="pet.type_food",
                  label="Tipo de Comida",
                  type="text",
                  :error-messages="errors",
                  clearable,
                  required
                )
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Especie",
                rules="required"
              )
                v-autocomplete(
                  v-model="pet.specie",
                  label="Especie",
                  :items="species",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="4")
              v-checkbox(label="Esterilizado", v-model="pet.sterilized")
            v-col(cols="12", md="8")
              ValidationProvider(
                v-slot="{ errors }",
                name="Fotografía",
                rules="image"
              )
                v-file-input(
                  v-model="pet.picture",
                  label="Fotografía",
                  value="1",
                  :show-size="true",
                  :error-messages="errors"
                )
          v-row(v-if="user.role.slug != 'owner'")
            v-col(cols="12", md="4")
              ValidationProvider(v-slot="{ errors }", name="Tag")
                v-autocomplete(
                  single-line,
                  label="Tag",
                  hide-details,
                  item-value="id",
                  item-text="code",
                  :items="inventory_tag",
                  :error-messages="errors",
                  v-model="pet.locator_tag",
                  :disabled="user.role.slug=='owner'",
                )
                  template(v-slot:item='data')
                    v-list-item-icon
                      v-chip(:color="!data.item.available ? 'green' : 'red'")
                        label.white--text(v-if="!data.item.available") Asignado
                        label.white--text(v-else) No Asignado
                    v-list-item-content
                      v-list-item-title(v-html='data.item.code')
            v-col(cols="12", md="4")
              ValidationProvider(v-slot="{ errors }", name="Chip")
                v-autocomplete(
                  single-line,
                  hide-details,
                  label="Chip",
                  item-value="id",
                  item-text="code",
                  :items="inventory_chip",
                  :error-messages="errors",
                  v-model="pet.locator_chip",
                  :disabled="user.role.slug=='owner'",
                )
                  template(v-slot:item='data')
                    v-list-item-icon
                      v-chip(:color="!data.item.available ? 'green' : 'red'")
                        label.white--text(v-if="!data.item.available") Asignado
                        label.white--text(v-else) No Asignado
                    v-list-item-content
                      v-list-item-title(v-html='data.item.code')
            v-col(cols="12", md="4")
              ValidationProvider(v-slot="{ errors }", name="Collar")
                v-autocomplete(
                  hide-details
                  single-line,
                  label="Collar",
                  item-value="id",
                  item-text="code",
                  :error-messages="errors",
                  :items="inventory_collar",
                  v-model="pet.locator_collar",
                  :disabled="user.role.slug=='owner'",
                )
                  template(v-slot:item='data')
                    v-list-item-icon
                      v-chip(:color="!data.item.available ? 'green' : 'red'")
                        label.white--text(v-if="!data.item.available") Asignado
                        label.white--text(v-else) No Asignado
                    v-list-item-content
                      v-list-item-title(v-html='data.item.code')
          v-row
            v-col(cols="12")
              ValidationProvider(v-slot="{ errors }", name="Condición")
                v-textarea(
                  v-model="pet.condition",
                  label="Condición",
                  type="text",
                  :error-messages="errors",
                  clearable
                )
      v-card-actions
        v-spacer
        v-btn(
          color="secondary",
          @click="createUpdatePet",
          :loading="loading",
          :disabled="loading"
        ) Guardar
</template>

<script>
import moment from "moment";
import petAPI from "@/api/pet";
import utils from "@/resources/utils";
import { mapGetters, mapState } from "vuex";
import { required, min, numeric, image } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} No puede ser vacío"
});

extend("min", {
  ...min,
  message: "{_field_} No puede ser menor que {length} caracteres"
});

extend("numeric", {
  ...numeric,
  message: "{_field_} Solo admite números"
});

extend("image", {
  ...image,
  message: "{_field_} Debe ser una imagen"
});

export default {
  name: "CreateUpdatePet",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    update: {
      type: Boolean,
      required: false,
      default: false
    },
    id_pet: {
      type: Number | String,
      required: false,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      choices: "selectChoices",
      inventory_tag: "inventories/inventoryTag",
      inventory_chip: "inventories/inventoryChip",
      inventory_collar: "inventories/inventoryCollar"
    }),
    ...mapState({
      user: state => state.auth.user,
      auth_token: state => state.auth.auth_token,
      vets: state => state.users.vets_without_pagination,
      owners: state => state.users.owners_without_pagination,
      species: state => state.species.speciesWithoutPagination
    }),
    dateFormatted() {
      return this.pet.birthday
        ? moment(this.pet.birthday)
            .locale("es")
            .format("LL")
        : "";
    }
  },
  async created() {
    await this.loadData();
    if (this.update) {
      const response = await petAPI.getPet(this.id_pet, this.auth_token);
      this.overlay = false;
      if (response.status) {
        this.pet = response.data.pet;
        this.pet.gender = "" + response.data.pet.gender;
        this.pet.picture = null;
        // this.pet.vet = response.data.vet != null ? response.data.vet.id : null
        this.pet.owner =
          response.data.owner != null ? response.data.owner.id : null;
        this.pet.specie =
          response.data.pet.specie != null ? response.data.pet.specie.id : null;
        this.pet.locator_tag =
          response.data.locator_tag != null
            ? response.data.locator_tag.id
            : null;
        this.pet.locator_chip =
          response.data.locator_chip != null
            ? response.data.locator_chip.id
            : null;
        this.pet.locator_collar =
          response.data.locator_collar != null
            ? response.data.locator_collar.id
            : null;
      } else {
        this.$swal({
          icon: "warning",
          title: response.data
        });
      }
    }
    this.overlay = false;
  },
  data() {
    return {
      overlay: true,
      loading: false,
      menu_date: false,
      messages_error_request: null,
      pet: {
        vet: null,
        name: null,
        race: null,
        color: null,
        owner: null,
        weight: null,
        specie: null,
        picture: null,
        gender: null,
        condition: null,
        type_food: null,
        sterilized: null,
        locator_tag: null,
        locator_chip: null,
        locator_collar: null,
        birthday: new Date().toISOString().substr(0, 10)
      }
    };
  },
  methods: {
    async createUpdatePet() {
      this.messages_error_request = null;
      if (await this.$refs.observer_pet_data.validate()) {
        this.loading = true;
        const pet = utils.formDataConvert(this.pet, this.user.role.slug);
        if (this.update) {
          const response = await petAPI.updatePet(
            this.id_pet,
            pet,
            this.auth_token
          );
          response.status
            ? await this.getPets(this.update)
            : this.$swal({
                icon: "success",
                title: response.data
              });
        } else {
          const response = await petAPI.createPet(pet, this.auth_token);
          response.status
            ? await this.getPets(this.update)
            : this.$swal({
                icon: "warning",
                title: response.data
              });
        }
        this.loading = false;
      }
    },
    async getPets(action) {
      let title = "";
      action ? (title = "Actualizada") : (title = "Creada");
      this.$swal({
        title: `Mascota ${title}`,
        icon: "success"
      });
      await this.$store.dispatch("pets/getPets", {
        page: 1,
        token: this.auth_token,
      });
    },
    async loadData() {
      await this.$store.dispatch("users/getUserWithoutPagination", {
        vet: true,
        owner: false,
        token: this.auth_token
      });
      await this.$store.dispatch("users/getUserWithoutPagination", {
        vet: false,
        owner: true,
        token: this.auth_token
      });
      await this.$store.dispatch("inventories/getInventories", {
        page: 1,
        assign: false,
        no_assign: false,
        pagination: false,
        token: this.auth_token
      });
      await this.$store.dispatch(
        "species/getSpeciesWithoutPagination",
        this.auth_token
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.alert {
  padding: 15px;
}
</style>
